import { render } from "./Chip.vue?vue&type=template&id=22694d2a&scoped=true&ts=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"

import "./Chip.vue?vue&type=style&index=0&id=22694d2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22694d2a"]])

export default __exports__